import { render, staticRenderFns } from "./hot-special-item.vue?vue&type=template&id=40e81c32&"
import script from "./hot-special-item.vue?vue&type=script&lang=ts&"
export * from "./hot-special-item.vue?vue&type=script&lang=ts&"
import style0 from "./hot-special-item.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports